import React, { useCallback, useEffect, useState } from 'react';

// A grid of photos. Clicking one opens it large; arrow keys and Escape work.
// images: [{ id, src, caption }]
const Lightbox = ({ images }) => {
  const [open, setOpen] = useState(-1);
  const close = useCallback(() => setOpen(-1), []);
  const step = useCallback((d) => setOpen((i) => (i < 0 ? i : (i + d + images.length) % images.length)), [images.length]);

  useEffect(() => {
    if (open < 0) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') step(1);
      else if (e.key === 'ArrowLeft') step(-1);
    };
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [open, close, step]);

  return (
    <>
      <div className="sc-photo-grid">
        {images.map((im, i) => (
          <button type="button" key={im.id || i} className="sc-photo" onClick={() => setOpen(i)} aria-label={im.caption ? `Open photo: ${im.caption}` : 'Open photo'}>
            <img src={im.src} alt={im.caption || ''} loading="lazy" />
          </button>
        ))}
      </div>
      {open >= 0 && (
        <div className="sc-lightbox" role="dialog" aria-modal="true" aria-label="Photo" onClick={close}>
          <button type="button" className="sc-lightbox__close" onClick={close} aria-label="Close">&times;</button>
          {images.length > 1 && (
            <>
              <button type="button" className="sc-lightbox__nav is-prev" onClick={(e) => { e.stopPropagation(); step(-1); }} aria-label="Previous photo">&lsaquo;</button>
              <button type="button" className="sc-lightbox__nav is-next" onClick={(e) => { e.stopPropagation(); step(1); }} aria-label="Next photo">&rsaquo;</button>
            </>
          )}
          <figure onClick={(e) => e.stopPropagation()}>
            <img src={images[open].src} alt={images[open].caption || ''} />
            {images[open].caption && <figcaption>{images[open].caption}</figcaption>}
          </figure>
        </div>
      )}
    </>
  );
};

export default Lightbox;
